module.exports = __webpack_public_path__ + "static/brad-a2c543e61cd4fbf00c0a167e1e2d62e6.jpg";